import { Grid } from "@material-ui/core";
import BPago from "./BPagos";
import TPagos from "./TPagos";
import BotonPago from "./FPago";
export default function VPagoUnico() {
  return (
    <Grid container>
      <Grid item xs={3}>
        <BPago />
      </Grid>
      <Grid item xs={9}>
        <div>
          <BotonPago/>
          <TPagos />
        </div>
      </Grid>
    </Grid>
  );
}
